export type Point = [number, number];
export type Polygon = Point[];

export const pointWithinPolygon = (point: Point, polygon: Polygon) => {
  //A point is in a polygon if a line from the point to infinity crosses the polygon an odd number of times
  let odd = false;
  //For each edge (In this case for each point of the polygon and the previous one)
  for (let i = 0, j = polygon.length - 1; i < polygon.length; i++) {
    //If a line from the point into infinity crosses this edge
    if (
      polygon[i][1] > point[1] !== polygon[j][1] > point[1] && // One point needs to be above, one below our y coordinate
      // ...and the edge doesn't cross our Y corrdinate before our x coordinate (but between our x coordinate and infinity)
      point[0] <
        ((polygon[j][0] - polygon[i][0]) * (point[1] - polygon[i][1])) /
          (polygon[j][1] - polygon[i][1]) +
          polygon[i][0]
    ) {
      // Invert odd
      odd = !odd;
    }
    j = i;
  }
  //If the number of crossings was odd, the point is in the polygon
  return odd;
};

export const getEnterPointPlacement = (enterPoint: Point, rect: DOMRect) => {
  const { top, right, bottom, left } = rect;
  const [x, y] = enterPoint;
  const placementX = x < left ? 'left' : x > right ? 'right' : null;
  const placementY = y < top ? 'top' : y > bottom ? 'bottom' : null;
  return [placementX, placementY] as const;
};

export function getElementPolygon(enterPoint: Point, currentPanel: Element, nextPanel: Element) {
  const nextRect = nextPanel.getBoundingClientRect();
  const currRect = currentPanel.getBoundingClientRect();
  const { top, bottom, left } = nextRect;
  const polygon = [enterPoint];
  const [, y] = enterPoint;

  const TRIANGLE_PADDING = 10;
  polygon.push([left, Math.min(top, y, currRect.top) - TRIANGLE_PADDING]);
  polygon.push([left, Math.max(bottom, y, currRect.bottom) + TRIANGLE_PADDING]);

  return polygon;
}
